

<!-- Search and NEW -->
<div class="flexie-auto-grid p-b-20">
  <div>
    <h3>Search</h3>
    <!-- <app-ui-search [searchables]="['Policy Number','Registration Number','Customer Name','Claimant Name','Claimant Telephone Number','Claimant Email']"></app-ui-search> -->
  </div>
  <div class="text-a-right">
    <button nz-button [nzType]="'primary'" (click)="newRegn()"><i nz-icon nzType="plus"  nzTheme="outline"></i> New Registration</button>
  </div>
</div>

<h3 class="heading">Last 5 Registrations</h3>

<!-- Data -->
<nz-table [nzData]="dataSet" [nzScroll]="{ x: '1500px'}">
  <thead>
  <tr>
    <th>Policy Number</th>
    <th>Reg. Number</th>
    <th>Reg. Date</th>
    <th>Insured Name</th>
    <th>Claimant Name</th>
    <th>Claimant Telephone</th>
    <th>Claimant Email</th>
    <th>Claim Date</th>
    <th>Claim Status</th>
    <th>Event Type</th>
  </tr>
  </thead>
  <tbody>
  <tr>
    <td>P009LIF994</td>
    <td><a routerLink="/app/claims/details/registration/claims-life">REGH00229867</a></td>
    <td>22 Apr 2019, 9:11 AM</td>
    <td>Uma Thurman</td>
    <td>Thomas Thurman</td>
    <td>8978871509</td>
    <td>tom@the-thurmans.com</td>
    <td>20 Apr 2019</td>
    <td>Registered</td>
    <td>Death</td>
  </tr>
  <tr>
    <td>P006HLT899</td>
    <td><a routerLink="/app/claims/details/registration/claims-life">REGH00233789</a></td>
    <td>21 Apr 2019, 09:12 AM</td>
    <td>George Martin</td>
    <td>Kim Martin</td>
    <td>9866510092</td>
    <td>kimmygal92@gmail.com</td>
    <td>20 Apr 2019</td>
    <td>Registered</td>
    <td>Critical Illness</td>
  </tr>
  <tr>
    <td>P00I889U</td>
    <td><a routerLink="/app/claims/details/registration/claims-life">REGH00899784</a></td>
    <td>21 Apr 2019, 11:34 PM</td>
    <td>Kenny K</td>
    <td>Jim Reynolds</td>
    <td>872760091</td>
    <td>jimRay72@gmail.com</td>
    <td>19 Apr 2019</td>
    <td>Registered</td>
    <td>Death</td>
  </tr>
  <tr>
    <td>P009HLT778</td>
    <td><a routerLink="/app/claims/details/registration/claims-life">REGH0092267</a></td>
    <td>22 Apr 2019, 10:19 AM</td>
    <td>James Meadow</td>
    <td>Natasha Yan</td>
    <td>8769982761</td>
    <td>nat1986@gmail.com</td>
    <td>19 Apr 2019</td>
    <td>Registered</td>
    <td>Death</td>
  </tr>
  <tr>
    <td>P009HLT779</td>
    <td><a routerLink="/app/claims/details/registration/claims-life">REGH00998611</a></td>
    <td>20 Apr 2019, 10:19 PM</td>
    <td>Billy Cosby</td>
    <td>Astor Cosby</td>
    <td>878765098</td>
    <td>astorox667@gmail.com</td>
    <td>18 Apr 2019</td>
    <td>Registered</td>
    <td>Death</td>
  </tr>
  </tbody>
</nz-table>
